import { render, staticRenderFns } from "./MyStudent.vue?vue&type=template&id=f3f38274&"
import script from "./MyStudent.vue?vue&type=script&lang=js&"
export * from "./MyStudent.vue?vue&type=script&lang=js&"
import style0 from "./MyStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports